import VenueListSkeleton from './VenueListSkeleton';

export default VenueListSkeleton;
